import React from 'react';
import clsx from 'clsx';
import {
  Box,
  Card,
  Container,
  Typography,
  makeStyles
} from '@material-ui/core';
import Logo from '../../img/LOGO_GMI_aero.png';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    backgroundColor: 'var(--gmi-color)',
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0'
  },
  card: {
    alignSelf: 'center',
    margin: '20px 50px',
    padding: '50px',
    [theme.breakpoints.down('xs')]: {
      padding: '15px',
      margin: '15px'
    }
  },
  mainText: {
    color: 'var(--gmi-color)',
    fontWeight: '600',
    textAlign: 'center'
  },
  secondaryText: {
    color: '#3d3d3d',
    fontWeight: '500',
    textAlign: 'center',
    marginTop: '10px'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
}));

const Error404 = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={classes.pageContainer}>
      <Card
        className={clsx(classes.card, className)}
        elevation={2}
        {...rest}
      >
        <Box>
          <Container maxWidth="md">
            <Typography
              className={classes.mainText}
              variant="h4"
            >
              404: Sorry, page not found
            </Typography>
            <Typography
              className={classes.secondaryText}
              variant="subtitle2"
            >
              The content you are looking for is not available.
              Please use the navigation or previous button to go back.
            </Typography>
            <Box textAlign="center">
              <img
                alt="Under development"
                className={classes.image}
                src={Logo}
              />
            </Box>
          </Container>
        </Box>
      </Card>
    </div>
  );
};

export default Error404;
